// extracted by mini-css-extract-plugin
export var dropdown = "_gj-0";
export var imagePlaceholder = "_gj-2";
export var imageWrapper = "_gj-3";
export var productImage = "_gj-1";
export var truncateContainer = "_gj-4";
export var truncateText = "_gj-5";